import { Routes } from '@angular/router';
import { productionGuard } from './core/guards/production.guard';
import { securityCodeGuard } from './core/guards/security-code.guard';
import { TestsComponent } from './models/components/tests/tests.component';
import { FormModelDynamicFormService } from './models/services/form-model-dynamic-form.service';
import { ErrorComponent } from './shared/components/error/error.component';
import { CONNECTION_TYPE, OPERATION_TYPE } from './user-identification/models/user-identification';
import { DynamicFormService } from './user-identification/services/dynamic-form.service';
import { UserIdentificationComponent } from './user-identification/user-identification.component';

export const routes: Routes = [
	{
		path: '',
		component: UserIdentificationComponent,
	},
	// Enlaces de pruebas
	{
		path: 'pol',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.POL] },
	},
	{
		path: 'ocr',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.OCR] },
	},
	{
		path: 'ocr-canny',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.OCR_CANNY] },
	},
	{
		path: 'docs',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.DOCUMENTS] },
	},
	{
		path: 'choose',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.CHOOSE] },
	},
	{
		path: 'form',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.FORM] },
		providers: [{ provide: DynamicFormService, useClass: FormModelDynamicFormService }],
	},
	{
		path: 'connections/work-life',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.CONNECTIONS], type: CONNECTION_TYPE.WORK_LIFE },
	},
	{
		path: 'connections/bank',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.CONNECTIONS], type: CONNECTION_TYPE.BANK_SCORING },
	},
	{
		path: 'connections/scripture',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.CONNECTIONS], type: CONNECTION_TYPE.SCRIPTURE },
	},
	{
		path: 'connections/irpf',
		component: UserIdentificationComponent,
		data: { operations: [OPERATION_TYPE.CONNECTIONS], type: CONNECTION_TYPE.IRPF },
	},
	// IFrame - enlaces de pruebas
	{
		path: 'life-test',
		component: UserIdentificationComponent,
		data: { iframe: true, operations: [OPERATION_TYPE.POL] },
	},
	{
		path: 'iframe/pol',
		component: UserIdentificationComponent,
		data: { iframe: true, operations: [OPERATION_TYPE.POL] },
	},
	{
		path: 'iframe/ocr',
		component: UserIdentificationComponent,
		data: { iframe: true, operations: [OPERATION_TYPE.OCR] },
	},
	{
		path: 'iframe/ocr-canny',
		component: UserIdentificationComponent,
		data: { iframe: true, operations: [OPERATION_TYPE.OCR_CANNY] },
	},
	{
		path: 'models',
		loadChildren: () => import('./models/models.routes').then((m) => m.MODELS_ROUTES),
		canActivate: [productionGuard, securityCodeGuard],
	},
	{
		path: 'tests',
		component: TestsComponent,
		canActivate: [productionGuard, securityCodeGuard],
	},
	{
		path: 'error/:errorCode',
		component: ErrorComponent,
	},
	{ path: '', redirectTo: '', pathMatch: 'full' },
	{ path: '**', redirectTo: '' },
];
